import { Button, Label, makeStyles, Tooltip } from "@fluentui/react-components";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  DocumentBulletList20Regular,
  Dismiss24Regular,
  ChevronLeft20Regular,
} from "@fluentui/react-icons";
import MaterialReactTable, {
  type MRT_ColumnDef,
  type MRT_RowSelectionState,
} from "material-react-table";
import {
  convertStringToArray,
  formatedDate,
  getCaseCategoryByCaseType,
  getClientType,
  getYes_NoConversion,
  isObjectEmpty,
} from "../../../utils";
import ReactQuillComponent from "../../../components/ReactQuillComponent";
import "./style.css";
import {
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
} from "@fluentui/react-components";
import apiServices from "../../../service";
import CaseSummaryDetail from "./CaseSummaryDetail";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { Eye24Filled, EyeOff24Filled } from "@fluentui/react-icons";
import ContentLoader from "../../../components/Loader/ContentLoader";
import { useNavigate } from "react-router-dom";
import ASCButton from "../../../components/Button";
import {
  General,
  healthAssurance,
  incomeProtection,
  Investments,
  lifeAssurance,
  Mortages,
  pensions,
  savingsPlans,
  unitLinked,
} from "../../../shared/actionlistDetails";
import { providerDetail, reviewDetail } from "../../../shared/caseSummary";
import NoDataFound from "../../../components/NoDataFound/noDataFound";
import { POLICY_CASE_TYPE_MAP } from "../case/Policy/PolicyHomePage";
import OverlayLoader from "../../../components/OverlayLoader";
import { getAssetListItems } from "../../../redux/Case/assetSlice";
import { getLiabilityListItems } from "../../../redux/Case/liabilitySlice";
import { getPolicyListItems } from "../../../redux/Case/policySlice";
import { getCurrentStatusParam } from "../../../shared/caseActiveStatus";
import { ASSET_CASE_TYPE_MAP } from "../case/Asset/assetSubTypeConfig";
import { LIABILITY_CASE_TYPE_MAP } from "../case/Liability/LiabilityHomePage";
interface PropsType {
  [x: string]: any;
}
const useStyles = makeStyles({
  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 350px)",
  },
  error: {
    color: "red",
    fontSize: "17px",
    fontWeight: "bold",
  },
});
function CaseSummary(props: PropsType) {
  const navigate = useNavigate();
  const styles = useStyles();
  const dispatch: AppDispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [fundValue, setFundValue] = useState<any>();
  const [paymentValue, setPaymentValue] = useState<any>();
  const [withdrawalValue, setWithdrawalValue] = useState<any>();
  const [showNonCurrentCases, setShowNonCurrentCases] =
    useState<Boolean>(false);
  const columns = useMemo<MRT_ColumnDef<{ [key: string]: any }>[]>(
    () => [
      {
        accessorKey: "category",
        header: "Category",
      },
      {
        accessorKey: "case_type",
        header: "Case Type",
      },
      {
        accessorKey: "owner",
        header: "Owner",
      },
      {
        accessorKey: "subtype",
        header: "Subtype",
      },
      {
        accessorKey: "provider",
        header: "Provider",
      },
      {
        accessorKey: "reference",
        header: "Reference",
      },
      {
        accessorKey: "start_date",
        header: "Start Date",
        Cell: ({ row }: any) => <>{formatedDate(row.original.start_date)}</>,
      },
      {
        accessorKey: "value",
        header: "Value",
      },
      {
        accessorKey: "value_date",
        header: "Value Date",
        Cell: ({ row }: any) => <>{formatedDate(row.original.value_date)}</>,
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "report_note",
        header: "Report Note",
        Cell: ({ row }: any) => (
          <>
            <ReactQuillComponent value={row.original.report_note} />
          </>
        ),
      },
    ],
    [],
  );
  const [rowSelection, setRowSelection] = React.useState<MRT_RowSelectionState>(
    {},
  );
  const [caseListData, setCaseListData] = useState<{
    assets: any[];
    liability: any[];
    policy: any[];
  }>({ assets: [], liability: [], policy: [] });
  const hasAutoSwitched = useRef(false);
  const caseSummary = useMemo(
    () => [
      ...caseListData.assets,
      ...caseListData.liability,
      ...caseListData.policy,
    ],
    [caseListData],
  );
  const [reviewData, setReviewData] = useState<PropsType>({});
  const [providerData, setProviderData] = useState<PropsType>({});
  const [selectedItem, setSelectedItem] = useState<any | {}>({});
  const [currentPage, setCurrentPage] = useState("listing");
  const [activeTab, setActiveTab] = useState("");
  const [detailDataItems, setDetailDataItems] = useState([]);
  const [activeRowItemDetail, setActiveRowItemDetail] = useState<any | {}>({});
  const [providerList, setProviderList] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (caseSummary.length > 0 && Object.keys(rowSelection)[0] !== undefined) {
      let index = 0;
      index = caseSummary.findIndex(
        (x: any) => x.id === Object.keys(rowSelection)[0],
      );
      setSelectedItem(caseSummary[index]);
    }
  }, [rowSelection]);
  useEffect(() => {
    if (activeTab !== "") {
      getCaseDetail(activeTab);
    }
  }, [activeTab]);
  const getProviderDetails = () => {
    if (
      !isObjectEmpty(activeRowItemDetail) &&
      activeRowItemDetail?.provider_correspondence !== null
    ) {
      setIsLoading(true); // Start loading

      apiServices.systemManager.providers
        .getProvider(activeRowItemDetail.provider_correspondence)
        .then((response) => {
          if (response.data?.data) {
            setProviderList(response.data.data);
          }
        })
        .catch((err) => {
          console.log("err");
        })
        .finally(() => {
          setIsLoading(false); // Stop loading
        });
    } else {
      setProviderList({});
    }
  };

  useEffect(() => {
    getProviderDetails();
  }, [activeRowItemDetail]);

  const mapAssetItem = (val: any) => ({
    id: val.asset_id,
    customer_id: val.customer_id,
    category: "Asset",
    case_type: "Investment",
    owner: getClientType(val.joint_indicator),
    subtype: val.investment_subtype,
    provider: val.investment_provider,
    reference: val.investment_account_number,
    start_date: val.investment_start_date,
    value: val.current_value,
    value_date: val.value_date,
    status: val.investment_status,
    report_note: val.report_note,
    review_assigned: val.review_assigned,
    review_completed: val.review_completed,
    review_date: val.review_date,
    review_interval: val.review_interval,
    review_reason: val.review_reason,
    provider_correspondence: val.provider_correspondence,
  });

  const mapLiabilityItem = (val: any) => ({
    id: val.liability_id,
    customer_id: val.customer_id,
    category: "Liability",
    case_type: val.case_type,
    owner: getClientType(val.joint_indicator),
    subtype: val.subtype,
    provider: val.provider,
    reference: val.account_number,
    start_date: val.start_date,
    value: val.property_value,
    value_date: val?.value_date,
    status: val.status,
    report_note: val.report_note,
    review_assigned: val.review_assigned,
    review_completed: val.review_completed,
    review_date: val.review_date,
    review_interval: val.review_interval,
    review_reason: val.review_reason,
    provider_correspondence: val.provider_correspondence,
  });

  const mapPolicyItem = (val: any) => ({
    id: val.policy_id,
    customer_id: val.customer_id,
    category: "Policy",
    case_type: val.case_type,
    owner: getClientType(val.policy_holder),
    subtype: val.subtype,
    provider: val.provider,
    reference: val.policy_number,
    start_date: val.start_date,
    value: val.total_fund_value,
    value_date: val?.valuation_date,
    status: val.status,
    report_note: val.report_note,
    review_assigned: val.review_assigned,
    review_completed: val.review_completed,
    review_date: val.review_date,
    review_interval: val.review_interval,
    review_reason: val.review_note,
    provider_correspondence: val.provider_correspondence,
  });

  useEffect(() => {
    hasAutoSwitched.current = false;
  }, [props.clientId]);

  useEffect(() => {
    if (!props.clientId) return;
    setIsLoading(true);

    Promise.all([
      dispatch(
        getAssetListItems({
          customerId: props.clientId,
          caseType: ASSET_CASE_TYPE_MAP.investment,
          status: !showNonCurrentCases
            ? getCurrentStatusParam("asset")
            : undefined,
        }),
      ),
      dispatch(
        getLiabilityListItems({
          customerId: props.clientId,
          caseType: LIABILITY_CASE_TYPE_MAP.morgages,
          status: !showNonCurrentCases
            ? getCurrentStatusParam("liability")
            : undefined,
        }),
      ),
      dispatch(
        getPolicyListItems({
          customerId: props.clientId,
          status: !showNonCurrentCases
            ? getCurrentStatusParam("policy")
            : undefined,
        }),
      ),
    ])
      .then(([assetResult, liabilityResult, policyResult]: any[]) => {
        setIsLoading(false);
        const assetItems = Array.isArray(assetResult?.payload)
          ? assetResult.payload
          : [];
        const liabilityItems = Array.isArray(liabilityResult?.payload)
          ? liabilityResult.payload
          : [];
        const policyItems = Array.isArray(policyResult?.payload)
          ? policyResult.payload
          : [];

        setCaseListData({
          assets: assetItems.map(mapAssetItem),
          liability: liabilityItems.map(mapLiabilityItem),
          policy: policyItems.map(mapPolicyItem),
        });

        // Auto-switch to non-current only on the first load (not on manual toggle-back).
        if (!showNonCurrentCases && !hasAutoSwitched.current) {
          const totalItems =
            assetItems.length + liabilityItems.length + policyItems.length;
          if (totalItems === 0) {
            hasAutoSwitched.current = true;
            setShowNonCurrentCases(true);
          }
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        console.log("err");
      });
  }, [props.clientId, showNonCurrentCases, dispatch]);

  const getCaseDetail = (tab: string) => {
    switch (tab) {
      case "fund":
        apiServices.fund
          .getList(props.clientId, (selectedItem as { [key: string]: any }).id)
          .then((response) => {
            if (response.data) {
              if (response.data.data && response.data.data.result) {
                setDetailDataItems(response.data.data?.result || []);
                setFundValue(response.data.data?.total_fund);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        break;
      case "payments":
        apiServices.Payments.getPayments(
          (selectedItem as { [key: string]: any }).id,
          props.clientId,
        )
          .then((response) => {
            if (response.data) {
              if (response.data.data && response.data.data.result) {
                setDetailDataItems(response.data.data?.result || []);
                setPaymentValue(response.data.data?.total);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        break;
      case "withdrawals":
        apiServices.Withdrawals.getList(
          (selectedItem as { [key: string]: any }).id,
          props.clientId,
        )
          .then((response) => {
            if (response.data) {
              if (response.data.data && response.data.data.result) {
                setDetailDataItems(response.data.data?.result || []);
                setWithdrawalValue(response.data.data?.total);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        break;

      case "actions":
        apiServices.Actions.getActions(
          (selectedItem as { [key: string]: any }).id,
          props.clientId,
        )
          .then((response) => {
            if (response.data) {
              if (response.data.data) {
                setDetailDataItems(response.data.data);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        break;
      case "review":
        const selectedReview = selectedItem;
        setReviewData(selectedReview);
        break;
      case "provider":
        const selectedProvider = providerList;
        setProviderData(selectedProvider);
        break;
      case "valuations":
        apiServices.valuation
          .getvaluation(
            (selectedItem as { [key: string]: any }).id,
            props.clientId,
          )
          .then((response) => {
            if (response.data) {
              if (response.data.data) {
                setDetailDataItems(response.data.data);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!isObjectEmpty(selectedItem)) {
      getCaseDetails(selectedItem);
    }
  }, [selectedItem]);
  const getCaseDetails = (rowItem: any) => {
    setIsLoading(true); // Start the loader

    switch (rowItem.category) {
      case "Asset":
        apiServices.assets
          .getDetail(rowItem.id, rowItem.customer_id)
          .then((response) => {
            handleSuccessResponse(response);
          })
          .catch((err) => {
            handleErrorResponse(err);
          })
          .finally(() => {
            setIsLoading(false); // Stop the loader after the request
          });
        break;
      case "Liability":
        apiServices.liability
          .getDetail(rowItem.id, rowItem.customer_id)
          .then((response) => {
            handleSuccessResponse(response);
          })
          .catch((err) => {
            handleErrorResponse(err);
          })
          .finally(() => {
            setIsLoading(false); // Stop the loader after the request
          });
        break;
      case "Policy":
        apiServices.policy
          .getDetail(rowItem.id, rowItem.customer_id)
          .then((response) => {
            handleSuccessResponse(response);
          })
          .catch((err) => {
            handleErrorResponse(err);
          })
          .finally(() => {
            setIsLoading(false); // Stop the loader after the request
          });
        break;
      default:
        setIsLoading(false); // Ensure the loader is stopped in case of default
        break;
    }
  };

  const handleSuccessResponse = (response: any) => {
    if (
      response.data &&
      !response.data.isError &&
      !isObjectEmpty(response.data.data)
    ) {
      setActiveRowItemDetail(response.data.data);
    }
  };
  const handleErrorResponse = (err: any) => {
    console.log(err);
  };
  const renderClientType = (type: number) => (type ? getClientType(type) : "-");
  const renderDate = (date: string) => (date ? formatedDate(date) : "-");
  const renderRichText = (text: string) =>
    text ? <ReactQuillComponent value={text} width="100%" /> : "-";
  const renderYesorNo = (value: number) =>
    value ? getYes_NoConversion(value) : "-";

  const Details = (activeRowItemDetail: any) => {
    if (selectedItem.category === "Policy") {
      if (selectedItem.case_type === "Life Assurance") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              lifeAssurance.length > 0 &&
              lifeAssurance.map((policyLA: any) => (
                <div key={policyLA.lifeAssurance_id} className="case_details">
                  <p className="details_label">{policyLA.label} </p>
                  <p>
                    {(() => {
                      switch (policyLA.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "mortgage_link":
                          return renderYesorNo(
                            activeRowItemDetail.mortgage_link,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "valuation_date":
                          return renderDate(activeRowItemDetail.valuation_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return activeRowItemDetail[policyLA.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Pensions") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              pensions.length > 0 &&
              pensions.map((policypensions: any) => (
                <div key={policypensions.lifeAssurance_id} className="details">
                  <p className="details_label">{policypensions.label} </p>
                  <p>
                    {(() => {
                      switch (policypensions.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "valuation_date":
                          return renderDate(activeRowItemDetail.valuation_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return (
                            activeRowItemDetail[policypensions.value] || "-"
                          );
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Savings Plans") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              savingsPlans.length > 0 &&
              savingsPlans.map((policySP: any) => (
                <div key={policySP.lifeAssurance_id} className="details">
                  <p className="details_label">{policySP.label} </p>
                  <p>
                    {(() => {
                      switch (policySP.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "valuation_date":
                          return renderDate(activeRowItemDetail.valuation_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return activeRowItemDetail[policySP.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Income Protection") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              incomeProtection.length > 0 &&
              incomeProtection.map((policyIP: any) => (
                <div key={policyIP.lifeAssurance_id} className="details">
                  <p className="details_label">{policyIP.label} </p>
                  <p>
                    {(() => {
                      switch (policyIP.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "valuation_date":
                          return renderDate(activeRowItemDetail.valuation_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return activeRowItemDetail[policyIP.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Health Assurance") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              healthAssurance.length > 0 &&
              healthAssurance.map((policyHA: any) => (
                <div key={policyHA.healthAssurance_id} className="details">
                  <p className="details_label">{policyHA.label} </p>
                  <p>
                    {(() => {
                      switch (policyHA.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return activeRowItemDetail[policyHA.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "General") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              General.length > 0 &&
              General.map((policyGeneral: any) => (
                <div key={policyGeneral.lifeAssurance_id} className="details">
                  <p className="details_label">{policyGeneral.label}</p>
                  <p>
                    {(() => {
                      switch (policyGeneral.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return (
                            activeRowItemDetail[policyGeneral.value] || "-"
                          );
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Investments") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              Investments.length > 0 &&
              Investments.map((policyIInvestments: any) => (
                <div
                  key={policyIInvestments.Investments_id}
                  className="details"
                >
                  <p className="details_label">{policyIInvestments.label} </p>
                  <p>
                    {(() => {
                      switch (policyIInvestments.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "valuation_date":
                          return renderDate(activeRowItemDetail.valuation_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "benefit_text":
                          return renderRichText(
                            activeRowItemDetail.benefit_text,
                          );
                        case "in_trust_note":
                          return renderRichText(
                            activeRowItemDetail.in_trust_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return (
                            activeRowItemDetail[policyIInvestments.value] || "-"
                          );
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      }
    } else if (selectedItem.category === "Asset") {
      if (selectedItem.case_type === "Investment") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              unitLinked.length > 0 &&
              unitLinked.map((investmentdata: any) => (
                <div key={investmentdata.lifeAssurance_id} className="details">
                  <p className="details_label">{investmentdata.label}</p>
                  <p>
                    {(() => {
                      switch (investmentdata.value) {
                        case "policy_holder":
                          return renderClientType(
                            activeRowItemDetail.policy_holder,
                          );
                        case "case_type":
                          return "Investment";
                        case "investment_start_date":
                          return renderDate(
                            activeRowItemDetail.investment_start_date,
                          );
                        case "investment_end_date":
                          return renderDate(
                            activeRowItemDetail.investment_end_date,
                          );
                        case "value_date":
                          return renderDate(activeRowItemDetail.value_date);
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "admin_note":
                          return renderRichText(activeRowItemDetail.admin_note);
                        case "note_text":
                          return renderRichText(activeRowItemDetail.note_text);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return (
                            activeRowItemDetail[investmentdata.value] || "-"
                          );
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      }
    } else if (selectedItem.category === "Liability") {
      if (selectedItem.case_type === "Mortgages") {
        return (
          <div>
            {Object.keys(activeRowItemDetail).length !== 0 &&
              Mortages.length > 0 &&
              Mortages.map((Mortagesdata: any) => (
                <div key={Mortagesdata.Mortages_id} className="details">
                  <p className="details_label">{Mortagesdata.label} </p>
                  <p>
                    {(() => {
                      switch (Mortagesdata.value) {
                        case "joint_indicator":
                          return renderClientType(
                            activeRowItemDetail.joint_indicator,
                          );
                        case "start_date":
                          return renderDate(activeRowItemDetail.start_date);
                        case "end_date":
                          return renderDate(activeRowItemDetail.end_date);
                        case "amount_outstanding_date":
                          return renderDate(
                            activeRowItemDetail.amount_outstanding_date,
                          );
                        case "status_date":
                          return renderDate(activeRowItemDetail.status_date);
                        case "provider_note":
                          return renderRichText(
                            activeRowItemDetail.provider_note,
                          );
                        case "note_text":
                          return renderRichText(activeRowItemDetail.note_text);
                        case "report_note":
                          return renderRichText(
                            activeRowItemDetail.report_note,
                          );
                        default:
                          return activeRowItemDetail[Mortagesdata.value] || "-";
                      }
                    })()}
                  </p>
                </div>
              ))}
          </div>
        );
      } else if (selectedItem.case_type === "Loans/Lease/HP") {
        return <></>;
      }
    } else {
      return <>No data Found</>;
    }
  };
  // useEffect(() => {
  //   getAssetDetails(props.clientId);
  //   getLiabilityDetails(props.clientId);
  //   getPolicyDetails(props.clientId);
  // }, []);

  const selectSubTab = (tab: string) => {
    setActiveTab(tab);
    setCurrentPage("detail");
  };
  const handleClick = () => {
    if (selectedItem.category === "Asset") {
      // Case summary only fetches Unit-linked assets (see mapAssetItem)
      navigate(
        `/clients/${selectedItem.customer_id}/assets/investment/${selectedItem.id}/asset/edit`,
      );
    } else if (selectedItem.category === "Liability") {
      navigate(
        `/clients/${selectedItem.customer_id}/liabilities/${getCaseCategoryByCaseType(selectedItem.case_type)}/${selectedItem.id}/liability/edit`,
      );
    } else {
      const policyCaseTypeSegment = Object.keys(POLICY_CASE_TYPE_MAP).find(
        (segment) => POLICY_CASE_TYPE_MAP[segment] === selectedItem.case_type,
      );
      navigate(
        `/clients/${selectedItem.customer_id}/policies/${policyCaseTypeSegment || "life-assurance"}/${selectedItem.id}/policy/edit`,
      );
    }
  };

  return (
    <>
      <OverlayLoader isLoading={isLoading} />
      <div className="case_summary">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("details_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              disabled={
                isObjectEmpty(selectedItem) ||
                convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("details_btn_case_summary")
              }
              onClick={() => {
                setIsOpen(true);
              }}
              icon={<DocumentBulletList20Regular />}
              style={{ width: "fit-content" }}
              size="medium"
              label="Details"
            />
          ) : (
            ""
          )}
        </div>
        <div style={{ display: "flex", gap: 10, margin: "10px 0" }}>
          {selectedItem &&
            Object.keys(selectedItem).length !== 0 &&
            currentPage !== "listing" && (
              <>
                {!convertStringToArray(
                  process.env.REACT_APP_HIDE_CTA_BUTTON,
                ).includes("back_to_case_summary") ? (
                  <Button
                    shape="rounded"
                    disabled={
                      !convertStringToArray(
                        process.env.REACT_APP_DISABLE_CTA_BUTTON,
                      ).includes("back_to_case_summary")
                        ? false
                        : true
                    }
                    size="medium"
                    icon={<ChevronLeft20Regular />}
                    onClick={() => {
                      setActiveTab("");
                      setCurrentPage("listing");
                    }}
                  >
                    <span style={{ color: "red" }}>Back to Case Summary</span>
                  </Button>
                ) : (
                  ""
                )}
              </>
            )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("funds_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "fund" ? "black" : undefined,
                color: activeTab === "fund" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("fund");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("funds_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Funds"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("payments_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "payments" ? "black" : undefined,
                color: activeTab === "payments" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("payments");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("payments_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Payments"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("withdrawals_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "withdrawals" ? "black" : undefined,
                color: activeTab === "withdrawals" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("withdrawals");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("withdrawals_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Withdrawals"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("actions_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "actions" ? "black" : undefined,
                color: activeTab === "actions" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("actions");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("actions_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Actions"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("review_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "review" ? "black" : undefined,
                color: activeTab === "review" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("review");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("review_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Review"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("provider_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "provider" ? "black" : undefined,
                color: activeTab === "provider" ? "white" : undefined,
              }}
              size="medium"
              onClick={() => {
                selectSubTab("provider");
              }}
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("provider_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Provider"
            />
          ) : (
            ""
          )}
          {!convertStringToArray(
            process.env.REACT_APP_HIDE_CTA_BUTTON,
          ).includes("valuations_btn_case_summary") ? (
            <ASCButton
              shape="rounded"
              style={{
                background: activeTab === "valuations" ? "black" : undefined,
                color: activeTab === "valuations" ? "white" : undefined,
              }}
              onClick={() => {
                selectSubTab("valuations");
              }}
              size="medium"
              disabled={
                !convertStringToArray(
                  process.env.REACT_APP_DISABLE_CTA_BUTTON,
                ).includes("valuations_btn_case_summary") &&
                selectedItem !== undefined &&
                Object.keys(selectedItem).length !== 0
                  ? false
                  : true
              }
              label="Valuations"
            />
          ) : (
            ""
          )}
        </div>

        <div className="caseSummary">
          {currentPage === "listing" ? (
            <MaterialReactTable
              columns={columns as any}
              data={caseSummary}
              enableRowSelection
              enableColumnActions={false}
              onRowSelectionChange={setRowSelection}
              enablePagination={false}
              // enableRowNumbers
              enableBottomToolbar={false}
              rowNumberMode="static"
              enableMultiRowSelection={false}
              muiTableBodyRowProps={({ row }: any) => ({
                onClick: row.getToggleSelectedHandler(),
                title: "Double-click here to edit the record",
                onDoubleClick: () => {
                  // row.getToggleSelectedHandler();
                  // dispatch(
                  //   setDialogModalOptions({
                  //     open: true,
                  //     contact_history_data: row.original,
                  //     type: row.original.category,
                  //     case_type: row.original.case_type,
                  //     setActiveItem: props.setActiveItem,
                  //     activeClient: props.activeClient,
                  //     customerId: props.activeCustomerId,
                  //     close: {
                  //       onclick: () => {
                  //         dispatch(setDialogModalOptions({ open: false }));
                  //       },
                  //       label: "Cancel",
                  //     },
                  //   })
                  // );
                  handleClick();
                },
                sx: { cursor: "pointer" },
              })}
              getRowId={(row) => row.id}
              enableRowActions={false}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "Actions", //change header text
                  // size: 300, //make actions column wider
                  muiTableHeadCellProps: {
                    align: "center",
                  },
                  muiTableBodyCellProps: {
                    align: "center",
                  },
                },
              }}
              renderTopToolbarCustomActions={({ table }) => (
                <>
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_CTA_BUTTON,
                  ).includes("non_current_btn_case_summary") ? (
                    <Button
                      shape="rounded"
                      disabled={
                        !convertStringToArray(
                          process.env.REACT_APP_DISABLE_CTA_BUTTON,
                        ).includes("non_current_btn_case_summary")
                          ? false
                          : true
                      }
                      style={{ marginTop: "15px" }}
                      onClick={() =>
                        setShowNonCurrentCases(!showNonCurrentCases)
                      }
                      icon={
                        showNonCurrentCases ? (
                          <EyeOff24Filled />
                        ) : (
                          <Eye24Filled />
                        )
                      }
                      size="medium"
                      title={
                        showNonCurrentCases
                          ? ""
                          : "Activating the button filters the list to show 'In-force', 'Pending,' and 'Active' statuses"
                      }
                    >
                      {showNonCurrentCases ? "Hide" : "Show"} non-current Cases
                    </Button>
                  ) : (
                    ""
                  )}
                </>
              )}
              initialState={{
                columnPinning: { right: ["mrt-row-actions"] },
              }}
              positionActionsColumn="last"
              positionToolbarAlertBanner="bottom"
              state={{ rowSelection }}
            />
          ) : (
            <>
              <CaseSummaryDetail
                data={detailDataItems}
                context={activeTab}
                fundValue={fundValue}
                paymentValue={paymentValue}
                withdrawalValue={withdrawalValue}
              />
              {activeTab == "review" ? (
                <div className="review_provider_container">
                  {Object.keys(reviewData).length !== 0 &&
                    reviewDetail.length > 0 &&
                    reviewDetail.map((review: any) => (
                      <div className="review_provider">
                        <p className="details_label">{review.label}</p>
                        <p>
                          {(() => {
                            switch (review.value) {
                              case "review_date":
                                return renderDate(reviewData.review_date);
                              case "review_completed":
                                return renderDate(reviewData.review_completed);
                              case "review_reason":
                                return renderRichText(reviewData.review_reason);
                              case "review_interval":
                                return reviewData.review_interval
                                  ? `${reviewData.review_interval} months`
                                  : "0 months";
                              default:
                                return reviewData[review.value] || "-";
                            }
                          })()}
                        </p>
                      </div>
                    ))}
                </div>
              ) : null}

              {activeTab == "provider" && (
                <div className="review_provider_container">
                  {Object.keys(providerData).length !== 0 &&
                  providerDetail.length > 0 ? (
                    providerDetail.map((provider: any) => (
                      <div className="review_provider">
                        <p className="details_label">{provider.label}</p>
                        <p>
                          {(() => {
                            switch (provider.value) {
                              case "note_text":
                                return renderRichText(providerData.note_text);
                              default:
                                return providerData[provider.value] || "-";
                            }
                          })()}
                        </p>
                      </div>
                    ))
                  ) : (
                    <div className={styles.emptyState}>
                      <Label className={styles.error}>
                        There are no provider for selected case
                      </Label>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>

        <OverlayDrawer
          position={"end"}
          open={isOpen}
          onOpenChange={(_, { open }) => setIsOpen(open)}
          className={"common-drawer"}
          style={{ width: "400px" }}
        >
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <ASCButton
                  shape="rounded"
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={() => setIsOpen(false)}
                />
              }
            >
              Details
            </DrawerHeaderTitle>
          </DrawerHeader>

          <DrawerBody>{Details(activeRowItemDetail)}</DrawerBody>
        </OverlayDrawer>
      </div>
    </>
  );
}

export default CaseSummary;
